<template>
  <div>
    <div class="row">
      <HorizontalDonutChartWidgetV2
        v-if="!hidden.includes('packs')"
        style="width: 450px; height: 200px"
        :title="'Packs'"
        :hidePercentage="false"
        :data="scansUsedData"
        :options="{responsive: true, maintainAspectRatio: true,}"
      />

      <HorizontalDonutChartWidgetV2
        v-if="!hidden.includes('accessCodes')"
        style="width: 450px; margin-left: 10px; height: 200px"
        :title="$t('biosigns.accessCodes.title')"
        :hidePercentage="false"
        :data="accessCodesData"
        :options="{responsive: true, maintainAspectRatio: true}"
      />

    </div>
  </div>
</template>
<script>
import HorizontalDonutChartWidgetV2 from '@/components/common/statistics/HorizontalDonutChartWidgetV2.vue';
import { IframeService } from '@/api/IframeService';

export default {
  props: {
    hidden: {
      type: Array,
      required: false,
      default: () => []
    },
    filters: {
      type: Object, required: true
    }
  },
  components: { HorizontalDonutChartWidgetV2 },
  mounted() {
    this.getStatsData()
  },
  data: function() {
    return {
      statsData: {
        accessCodeStats: {
          active: 0,
          used: 0,
          expired: 0
        },
        scanPacksStats: {
          free: 0,
          used: 0
        },
      }
    }
  },
  methods: {
    getStatsData: function() {
      IframeService.getBiosignsStats(this.filters.entities === null ? '' : this.filters.entities.id).then(res => {
        this.statsData = {...res}
      }).catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    scansUsedData: function() {
      return {
        labels: [
          this.$t('biosigns.accessCodes.packs.used'),
          this.$t('biosigns.accessCodes.packs.free')
        ],
        datasets: [{
          data: [this.statsData.scanPacksStats.used, this.statsData.scanPacksStats.free],
          backgroundColor: [
            '#c3ab74',
            '#cbdca2',
          ]
        }]
      }
    },
    accessCodesData: function() {
      return {
        labels: [
          this.$t('biosigns.accessCodes.statuses.active'),
          this.$t('biosigns.accessCodes.statuses.used'),
          this.$t('biosigns.accessCodes.statuses.expired'),
        ],
        datasets: [{
          data: [this.statsData.accessCodeStats.active,
            this.statsData.accessCodeStats.used,
            this.statsData.accessCodeStats.expired],
          backgroundColor: [
            '#cbdca2',
            '#c3ab74',
            '#e57e67',
          ]
        }]
      }
    }
  },
  watch: {
    'filters.entities': function() {
      this.getStatsData()
    }
  }
}

</script>

<style lang="scss">
.chart-widget-wrapper {
  padding-left: 0.35rem;
  padding-right: 0.35rem;
}

#doughnut-chart{
  width: 70% !important;
  height: unset !important;
}

</style>
